function getWebsiteOptions (websiteName) {
  if (websiteName === 'SOLO') {
    return [
      {'label': 'SOLO78', 'value': 'solo78'},
      {'label': 'SOLO789', 'value': 'solo789'},
      {'label': 'SOLO787', 'value': 'solo787'},
      {'label': 'SOLO79', 'value': 'solo79'},
      {'label': 'SOLO456', 'value': 'solo456'},
      {'label': 'SOLO44', 'value': 'solo44'},
      {'label': 'SOLO432', 'value': 'solo432'}
    ]
  }
  return [
    {'label': 'LALIKABET168', 'value': 'lalikabet168'},
    {'label': 'LALIKABET88', 'value': 'lalikabet88'},
    {'label': 'LALIKABET66', 'value': 'lalikabet66'}
  ]
}

export default getWebsiteOptions
